import React from 'react';
import styled, { CSSProp } from 'styled-components';
import { pxToRem } from 'src/common/utils/helpers';
import { Image } from '../image';

interface TextProps {
  as?: React.ElementType;
  css?: CSSProp;
  color?: string;
  display?: string;
  font?: string;
  fontFamily?: string;
  fontSize?: string;
  fontSizeAdjust?: string;
  fontStretch?: string;
  alignSelf?: string;
  backgroundColor?: string;
  borderRadius?: string;
  border?: string;
  flex?: string;
  fontStyle?: string;
  fontVariant?: string;
  fontWeight?: string | number;
  hyphens?: string;
  justifyContent?: string;
  letterSpacing?: string;
  lineHeight?: string;
  margin?: string;
  overflow?: string;
  overflowWrap?: string;
  padding?: string;
  tabSize?: string;
  textAlign?: string;
  textIndent?: string;
  textJustify?: string;
  textShadow?: string;
  textTransform?: string;
  textOverflow?: string;
  verticalAlign?: string;
  width?: string;
  whiteSpace?: string;
  wordBreak?: string;
  wordSpacing?: string;
  wordWrap?: string;
  position?: string;
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
  zIndex?: number;
  hoverTextDecoration?: string;
  textDecoration?: string;
  gap?: string;
  cursor?: string;
}

const Container = styled.div<TextProps>`
	user-select: auto;
  color: ${(props) => props.color || 'inherit'};
  display: ${(props) => props.display || 'block'};
  font: ${(props) => props.font || 'inherit'};
  font-family: ${(props) => props.fontFamily || 'inherit'};
  font-size: ${(props) => (props.fontSize && pxToRem(props.fontSize)) || 'inherit'};
  font-size-adjust: ${(props) => props.fontSizeAdjust || 'initial'};
  font-stretch: ${(props) => props.fontStretch || 'initial'};

  ${(props) => props.alignSelf && `align-self: ${props.alignSelf};`}
  ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`}
  ${(props) => props.borderRadius && `border-radius: ${pxToRem(props.borderRadius)};`}
  ${(props) => props.border && `border: ${pxToRem(props.border)};`}
  ${(props) => props.flex && `flex: ${props.flex};`}
  ${(props) => props.cursor && `cursor: ${props.cursor};`}
  ${(props) => props.fontStyle && `font-style: ${props.fontStyle};`}
  ${(props) => props.fontVariant && `font-variant: ${props.fontVariant};`}
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight};`}
  ${(props) => props.hyphens && `hyphens: ${props.hyphens};`}
  ${(props) => props.justifyContent && `justify-content: ${props.justifyContent};`}
  ${(props) => props.letterSpacing && `letter-spacing: ${pxToRem(props.letterSpacing)};`}
  ${(props) => props.lineHeight && `line-height: ${pxToRem(props.lineHeight)};`}
  ${(props) => props.margin && `margin: ${pxToRem(props.margin)};`}
  ${(props) => props.overflow && `overflow: ${props.overflow};`}
  ${(props) => props.overflowWrap && `overflow-wrap: ${props.overflowWrap};`}
  ${(props) => props.padding && `padding: ${pxToRem(props.padding)};`}
  ${(props) => props.tabSize && `tab-size: ${pxToRem(props.tabSize)};`}
  ${(props) => props.textAlign && `text-align: ${props.textAlign};`}
  ${(props) => props.textIndent && `text-indent: ${pxToRem(props.textIndent)};`}
  ${(props) => props.textJustify && `text-justify: ${props.textJustify};`}
  ${(props) => props.textShadow && `text-shadow: ${pxToRem(props.textShadow)};`}
  ${(props) => props.textTransform && `text-transform: ${props.textTransform};`}
  ${(props) => props.textOverflow && `text-overflow: ${props.textOverflow};`}
  ${(props) => props.verticalAlign && `vertical-align: ${props.verticalAlign};`}
  ${(props) => props.width && `width: ${pxToRem(props.width)};`}
  ${(props) => props.whiteSpace && `white-space: ${props.whiteSpace};`}
  ${(props) => props.wordBreak && `word-break: ${props.wordBreak};`}
  ${(props) => props.wordSpacing && `word-spacing: ${props.wordSpacing};`}
  ${(props) => props.wordWrap && `word-wrap: ${props.wordWrap};`}
  ${(props) => props.position && `position: ${props.position};`}
  ${(props) => props.top && `top: ${pxToRem(props.top)};`}
  ${(props) => props.left && `left: ${pxToRem(props.left)};`}
  ${(props) => props.bottom && `bottom: ${pxToRem(props.bottom)};`}
  ${(props) => props.right && `right: ${pxToRem(props.right)};`}
  ${(props) => props.zIndex && `z-index: ${props.zIndex};`}
  ${(props) => props.gap && `gap: ${pxToRem(props.gap)};`}
  ${(props) => props.textDecoration && `text-decoration: ${props.textDecoration};`}
  ${(props) => props.css}
  :hover {
    ${(props) => props.hoverTextDecoration && `text-decoration: ${props.hoverTextDecoration};`}
  }
`;

type Props = TextProps & {
  icon?: string;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

export const Text = (props: Props) => (
  <Container {...props}>
    {props.icon && <Image src={props.icon} alt="" />}
    {props.children}
  </Container>
);
